import React, { useState, useEffect } from 'react';
import { FiCalendar, FiShoppingCart, FiPackage, FiFileText, FiTrendingUp, FiFilter, FiRefreshCw, FiCheck, FiX, FiEye, FiEdit, FiTrash2, FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';
import bodegaService from '../services/bodegaService';
import { ordenCompraService } from '../services/onebaseService';
import CrearOrdenCompraOneBaseModal from '../components/CrearOrdenCompraOneBaseModal';
import VerEditarOrdenCompraModal from '../components/VerEditarOrdenCompraModal';
import RecepcionarCompraModal from '../components/RecepcionarCompraModal';
import CrearEditarDocumentoLegalModal from '../components/CrearEditarDocumentoLegalModal';
import Loading from '../components/Loading';
import './OrdenesCompraPage.css';
import './SolicitudesPage.css';
import './DocumentosLegalesPage.css';

const FlujoProcesosPage = () => {
  const [activeTab, setActiveTab] = useState('solicitudes');
  const [loading, setLoading] = useState(false);
  const [showFiltros, setShowFiltros] = useState(true);

  // Estados para cada sección
  const [tareas, setTareas] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [guiasDespacho, setGuiasDespacho] = useState([]);
  const [documentosLegales, setDocumentosLegales] = useState([]);
  const [movimientos, setMovimientos] = useState([]);

  // Estados para filas expandidas
  const [expandedSolicitud, setExpandedSolicitud] = useState(null);
  const [expandedOrden, setExpandedOrden] = useState(null);
  const [expandedGuia, setExpandedGuia] = useState(null);
  const [expandedDocumento, setExpandedDocumento] = useState(null);

  // Estados para modales de Solicitudes
  const [showCrearOCModal, setShowCrearOCModal] = useState(false);
  const [solicitudParaAprobar, setSolicitudParaAprobar] = useState(null);
  const [presupuestoData, setPresupuestoData] = useState(null);
  const [itemsSeleccionados, setItemsSeleccionados] = useState([]);

  // Estados para modales de Órdenes de Compra
  const [showVerEditarOC, setShowVerEditarOC] = useState(false);
  const [ordenCompraParaVer, setOrdenCompraParaVer] = useState(null);
  const [showRecepcionModal, setShowRecepcionModal] = useState(false);
  const [ordenCompraParaRecepcionar, setOrdenCompraParaRecepcionar] = useState(null);

  // Estados para modales de Documentos Legales
  const [showDocumentoModal, setShowDocumentoModal] = useState(false);
  const [documentoEdit, setDocumentoEdit] = useState(null);

  // Filtros generales
  const [filtros, setFiltros] = useState({
    fecha_desde: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    fecha_hasta: new Date().toISOString().split('T')[0],
    proyecto: '',
    estado: '',
    recurso: '',
    proveedor: '',
    numero: ''
  });

  useEffect(() => {
    cargarDatos();
  }, [activeTab]);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      switch (activeTab) {
        case 'tareas':
          await cargarTareas();
          break;
        case 'solicitudes':
          await cargarSolicitudes();
          break;
        case 'ordenes':
          await cargarOrdenesCompra();
          break;
        case 'guias':
          await cargarGuiasDespacho();
          break;
        case 'documentos':
          await cargarDocumentosLegales();
          break;
        case 'movimientos':
          await cargarMovimientos();
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
      toast.error('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const cargarTareas = async () => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/eventos');
      const response = await api.get(`${API_BASE_URL}/tareas/`);
      const data = response.data.results || response.data;
      setTareas(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error al cargar tareas:', error);
      setTareas([]);
    }
  };

  const cargarSolicitudes = async () => {
    try {
      const response = await bodegaService.getSolicitudesRecurso();
      setSolicitudes(response.data.results || response.data);
    } catch (error) {
      console.error('Error al cargar solicitudes:', error);
      setSolicitudes([]);
    }
  };

  const cargarOrdenesCompra = async () => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/onebase');
      const response = await api.get(`${API_BASE_URL}/ordenes-compra/`);
      setOrdenesCompra(response.data.results || response.data);
    } catch (error) {
      console.error('Error al cargar órdenes de compra:', error);
      setOrdenesCompra([]);
    }
  };

  const cargarGuiasDespacho = async () => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/bodega');
      const response = await api.get(`${API_BASE_URL}/guias-despacho/`);
      setGuiasDespacho(response.data.results || response.data);
    } catch (error) {
      console.error('Error al cargar guías de despacho:', error);
      setGuiasDespacho([]);
    }
  };

  const cargarDocumentosLegales = async () => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/contabilidad');
      const response = await api.get(`${API_BASE_URL}/documentos-legales/`);
      setDocumentosLegales(response.data.results || response.data);
    } catch (error) {
      console.error('Error al cargar documentos legales:', error);
      setDocumentosLegales([]);
    }
  };

  const cargarMovimientos = async () => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/bodega');
      const response = await api.get(`${API_BASE_URL}/movimientos/`);
      const data = response.data.results || response.data;
      setMovimientos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error al cargar movimientos:', error);
      setMovimientos([]);
    }
  };

  // =========================
  // Handlers para Solicitudes
  // =========================
  const handleAprobarSolicitud = async (solicitud) => {
    try {
      setSolicitudParaAprobar(solicitud);

      let presupuestoCostoId = 0;
      const primerDetalleConPresupuesto = solicitud.detalles?.find(d => d.recurso_data?.presupuesto_costo_id);

      if (primerDetalleConPresupuesto && primerDetalleConPresupuesto.recurso_data?.presupuesto_costo_id) {
        presupuestoCostoId = primerDetalleConPresupuesto.recurso_data.presupuesto_costo_id;
      }

      const presupuestoSimulado = {
        id: presupuestoCostoId,
        proyecto: solicitud.proyecto_data?.id || 0,
        proyecto_nombre: solicitud.proyecto_data?.nombre || 'N/A',
        version: 1,
      };

      const items = solicitud.detalles?.map(detalle => ({
        id: detalle.presupuesto_costo_recurso || detalle.recurso_data?.id || detalle.id,
        nombre: detalle.recurso_data?.nombre || 'Recurso',
        unidad: detalle.recurso_data?.unidad_medida || 'Un',
        cantidad_presupuestada_costo: detalle.recurso_data?.cantidad_presupuestada_costo || detalle.cantidad_solicitada,
        cantidad_presupuesto: detalle.recurso_data?.cantidad_presupuesto || detalle.cantidad_solicitada,
        cantidad_solicitada: detalle.recurso_data?.cantidad_solicitada || 0,
        cantidad_solicitada_oc: detalle.recurso_data?.cantidad_solicitada_oc || 0,
        cantidad_salidas_bodega: detalle.recurso_data?.cantidad_salidas_bodega || 0,
        cantidad_disponible: detalle.recurso_data?.cantidad_disponible || 0,
        precio_unitario_costo: detalle.recurso_data?.precio_unitario || 0,
        recurso_referencia: detalle.recurso,
        recurso_referencia_data: {
          ...detalle.recurso_data,
          stock: false
        },
        area_id: detalle.recurso_data?.area_id || null,
        partida_id: detalle.recurso_data?.partida_id || null,
        area_nombre: detalle.recurso_data?.area_nombre || 'Solicitud de Compra',
        partida_nombre: detalle.recurso_data?.partida_nombre || `Evento: ${solicitud.evento_data?.nombre || 'N/A'}`,
        cantidad_dias: 1,
        cantidad_inicial: detalle.cantidad || 0
      })) || [];

      setPresupuestoData(presupuestoSimulado);
      setItemsSeleccionados(items);
      setShowCrearOCModal(true);
    } catch (error) {
      console.error('Error al preparar aprobación:', error);
      toast.error('Error al preparar la orden de compra');
    }
  };

  const handleOCCreada = async () => {
    try {
      if (solicitudParaAprobar) {
        await bodegaService.aprobarSolicitudRecurso(solicitudParaAprobar.id);
        toast.success('Solicitud aprobada y Orden de Compra creada exitosamente');
        cargarSolicitudes();
      }
      setShowCrearOCModal(false);
      setSolicitudParaAprobar(null);
      setPresupuestoData(null);
      setItemsSeleccionados([]);
    } catch (error) {
      console.error('Error al aprobar solicitud:', error);
      toast.error('OC creada pero hubo un error al aprobar la solicitud');
    }
  };

  const handleRechazarSolicitud = async (solicitudId) => {
    const motivo = window.prompt('Ingrese el motivo del rechazo:');
    if (!motivo) return;

    try {
      await bodegaService.rechazarSolicitudRecurso(solicitudId, { motivo });
      toast.success('Solicitud rechazada');
      cargarSolicitudes();
    } catch (error) {
      console.error('Error al rechazar solicitud:', error);
      toast.error('Error al rechazar la solicitud');
    }
  };

  // ================================
  // Handlers para Órdenes de Compra
  // ================================
  const handleEditarOrdenCompra = (orden) => {
    setOrdenCompraParaVer(orden);
    setShowVerEditarOC(true);
  };

  const handleEliminarOrdenCompra = async (orden) => {
    if (!window.confirm(`¿Estás seguro de eliminar la Orden de Compra ${orden.numero_oc}?`)) {
      return;
    }

    try {
      await ordenCompraService.delete(orden.id);
      toast.success('Orden de compra eliminada correctamente');
      cargarOrdenesCompra();
    } catch (error) {
      console.error('Error al eliminar orden de compra:', error);
      toast.error('Error al eliminar la orden de compra');
    }
  };

  const handleRecepcionarCompra = async (orden) => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/onebase');
      const response = await api.get(`${API_BASE_URL}/ordenes-compra/${orden.id}/`);

      setOrdenCompraParaRecepcionar(response.data);
      setShowRecepcionModal(true);
    } catch (error) {
      console.error('Error al cargar orden de compra completa:', error);
      toast.error('Error al cargar los detalles de la orden de compra');
    }
  };

  // ==================================
  // Handlers para Documentos Legales
  // ==================================
  const handleCrearDocumento = () => {
    setDocumentoEdit(null);
    setShowDocumentoModal(true);
  };

  const handleEditarDocumento = async (documento) => {
    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/contabilidad');
      const response = await api.get(`${API_BASE_URL}/documentos-legales/${documento.id}/`);

      setDocumentoEdit(response.data);
      setShowDocumentoModal(true);
    } catch (error) {
      console.error('Error al cargar documento completo:', error);
      toast.error('Error al cargar el documento para editar');
    }
  };

  const handleEliminarDocumento = async (documentoId) => {
    if (!window.confirm('¿Está seguro de eliminar este documento?')) {
      return;
    }

    try {
      const baseURL = api?.defaults?.baseURL || '/api/content';
      const API_BASE_URL = baseURL.replace(/\/content\/?$/i, '/contabilidad');
      await api.delete(`${API_BASE_URL}/documentos-legales/${documentoId}/`);
      toast.success('Documento eliminado exitosamente');
      cargarDocumentosLegales();
    } catch (error) {
      console.error('Error al eliminar documento:', error);
      toast.error('Error al eliminar el documento');
    }
  };

  // ================================
  // Funciones de utilidad
  // ================================
  const formatFecha = (fecha) => {
    if (!fecha) return '-';
    return new Date(fecha).toLocaleDateString('es-CL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP'
    }).format(value);
  };

  const getEstadoBadgeClass = (estado) => {
    const estadosMap = {
      'pendiente': 'badge-pendiente',
      'aprobada': 'badge-aprobada',
      'aprobado': 'badge-aprobada',
      'rechazada': 'badge-rechazada',
      'completada': 'badge-completada',
      'emitida': 'badge-emitida',
      'recibida': 'badge-recibida',
      'recepcionado': 'badge-recibida',
      'borrador': 'badge-borrador',
      'completado': 'badge-completada',
      'facturada': 'badge-facturada',
      'pagada': 'badge-pagada',
      'vencida': 'badge-vencida',
      'anulada': 'badge-anulada',
      'cancelada': 'badge-cancelada'
    };
    return estadosMap[estado] || 'badge-default';
  };

  const getTipoBadgeClass = (tipo) => {
    const tipoMap = {
      'factura_compra': 'badge-factura-compra',
      'factura_venta': 'badge-factura-venta',
      'boleta': 'badge-boleta',
      'nota_credito': 'badge-nota-credito',
      'nota_debito': 'badge-nota-debito'
    };
    return tipoMap[tipo] || 'badge-default';
  };

  // ================================
  // Funciones de estadísticas
  // ================================
  const calcularEstadisticasTareas = () => {
    const stats = {};
    tareas.forEach(tarea => {
      const estado = tarea.estado || 'sin_estado';
      if (!stats[estado]) {
        stats[estado] = { count: 0, color: getEstadoColor(estado) };
      }
      stats[estado].count++;
    });
    return stats;
  };

  const calcularEstadisticasSolicitudes = () => {
    const stats = {};
    solicitudes.forEach(solicitud => {
      const estado = solicitud.estado || 'sin_estado';
      if (!stats[estado]) {
        stats[estado] = { count: 0, color: getEstadoColor(estado) };
      }
      stats[estado].count++;
    });
    return stats;
  };

  const calcularEstadisticasOrdenes = () => {
    const stats = {};
    ordenesCompra.forEach(orden => {
      const estado = orden.estado || 'sin_estado';
      if (!stats[estado]) {
        stats[estado] = { count: 0, total: 0, color: getEstadoColor(estado) };
      }
      stats[estado].count++;
      stats[estado].total += parseFloat(orden.total_oc || 0);
    });
    return stats;
  };

  const calcularEstadisticasGuias = () => {
    const stats = {};
    guiasDespacho.forEach(guia => {
      const estado = guia.estado || 'sin_estado';
      if (!stats[estado]) {
        stats[estado] = { count: 0, total: 0, color: getEstadoColor(estado) };
      }
      stats[estado].count++;
      stats[estado].total += parseFloat(guia.total_guia || 0);
    });
    return stats;
  };

  const calcularEstadisticasDocumentos = () => {
    const stats = {};
    documentosLegales.forEach(doc => {
      const estado = doc.estado || 'sin_estado';
      if (!stats[estado]) {
        stats[estado] = { count: 0, total: 0, color: getEstadoColor(estado) };
      }
      stats[estado].count++;
      stats[estado].total += parseFloat(doc.monto_total || 0);
    });
    return stats;
  };

  const calcularEstadisticasMovimientos = () => {
    const stats = {};
    movimientos.forEach(mov => {
      const tipo = mov.tipo_movimiento || 'sin_tipo';
      if (!stats[tipo]) {
        stats[tipo] = { count: 0, color: tipo === 'entrada' ? '#10b981' : tipo === 'salida' ? '#ef4444' : '#6b7280' };
      }
      stats[tipo].count++;
    });
    return stats;
  };

  const getEstadoColor = (estado) => {
    const colores = {
      'pendiente': '#f59e0b',
      'aprobada': '#3b82f6',
      'aprobado': '#3b82f6',
      'rechazada': '#ef4444',
      'completada': '#10b981',
      'completado': '#10b981',
      'emitida': '#3b82f6',
      'recibida': '#10b981',
      'recepcionado': '#10b981',
      'borrador': '#6b7280',
      'facturada': '#69B32D',
      'pagada': '#10b981',
      'vencida': '#ef4444',
      'anulada': '#94a3b8',
      'cancelada': '#94a3b8',
      'en_proceso': '#f59e0b',
      'sin_estado': '#cbd5e1'
    };
    return colores[estado] || '#cbd5e1';
  };

  const renderCompactStats = (stats, showTotal = false) => (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '0.75rem',
      marginBottom: '1.5rem'
    }}>
      {Object.entries(stats).map(([key, data]) => (
        <div
          key={key}
          style={{
            background: 'white',
            borderRadius: '8px',
            padding: '0.75rem',
            border: `2px solid ${data.color}`,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: '60px'
          }}
        >
          <div style={{ flex: 1 }}>
            <div style={{
              fontSize: '0.75rem',
              fontWeight: 600,
              color: '#6b7280',
              textTransform: 'capitalize',
              marginBottom: '0.25rem'
            }}>
              {key.replace(/_/g, ' ')}
            </div>
            {showTotal && data.total !== undefined && (
              <div style={{
                fontSize: '0.7rem',
                color: '#9ca3af',
                fontWeight: 500
              }}>
                {formatCurrency(data.total)}
              </div>
            )}
          </div>
          <div style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: data.color
          }}>
            {data.count}
          </div>
        </div>
      ))}
    </div>
  );

  // ================================
  // Renders por Tab
  // ================================
  const renderTareas = () => {
    const stats = calcularEstadisticasTareas();
    return (
      <div className="table-container">
        {Object.keys(stats).length > 0 && renderCompactStats(stats)}
        {tareas.length === 0 ? (
          <div className="empty-state">
            <FiCalendar size={64} />
            <h3>No hay tareas</h3>
            <p>No se encontraron tareas registradas</p>
          </div>
        ) : (
          <table className="solicitudes-table">
          <thead>
            <tr>
              <th>Título</th>
              <th>Evento</th>
              <th>Proyecto</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {tareas.map(tarea => (
              <tr key={tarea.id}>
                <td><strong>{tarea.titulo || tarea.nombre}</strong></td>
                <td>{tarea.evento_nombre || '-'}</td>
                <td>{tarea.proyecto_nombre || '-'}</td>
                <td>{formatFecha(tarea.fecha_inicio)}</td>
                <td>{formatFecha(tarea.fecha_fin)}</td>
                <td>
                  <span className={`estado-badge ${getEstadoBadgeClass(tarea.estado)}`}>
                    {tarea.estado}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      </div>
    );
  };

  const renderSolicitudes = () => {
    const stats = calcularEstadisticasSolicitudes();
    return (
      <div className="solicitudes-page">
        {Object.keys(stats).length > 0 && renderCompactStats(stats)}
        {solicitudes.length === 0 ? (
          <div className="empty-state">
            <FiFileText size={64} />
            <h3>No hay solicitudes</h3>
            <p>No se encontraron solicitudes de compra</p>
          </div>
        ) : (
          <div className="solicitudes-table-container">
          <table className="solicitudes-table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Recurso</th>
                <th>Proyecto</th>
                <th>Evento</th>
                <th>Tarea</th>
                <th>Cantidad</th>
                <th>Fecha Solicitud</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {solicitudes.map((solicitud) => (
                <React.Fragment key={solicitud.id}>
                  <tr className={`solicitud-row ${expandedSolicitud === solicitud.id ? 'expanded' : ''}`}>
                    <td>
                      <button
                        className="btn-expand"
                        onClick={() => setExpandedSolicitud(expandedSolicitud === solicitud.id ? null : solicitud.id)}
                      >
                        {expandedSolicitud === solicitud.id ? '▼' : '▶'}
                      </button>
                    </td>
                    <td>
                      <div className="recurso-info">
                        <strong>{solicitud.recurso_data?.nombre || '-'}</strong>
                        <small>{solicitud.recurso_data?.codigo || ''}</small>
                      </div>
                    </td>
                    <td>{solicitud.proyecto_data?.nombre || '-'}</td>
                    <td>{solicitud.evento_data?.nombre || '-'}</td>
                    <td>{solicitud.tarea_data?.nombre || '-'}</td>
                    <td>
                      <span className="cantidad-badge">
                        {solicitud.cantidad_solicitada} {solicitud.recurso_data?.unidad_medida || ''}
                      </span>
                    </td>
                    <td>{formatFecha(solicitud.created_at)}</td>
                    <td>
                      <span className={`estado-badge ${getEstadoBadgeClass(solicitud.estado)}`}>
                        {solicitud.estado}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        {solicitud.estado === 'pendiente' && (
                          <>
                            <button
                              className="btn-action btn-aprobar"
                              onClick={() => handleAprobarSolicitud(solicitud)}
                              title="Aprobar solicitud"
                            >
                              <FiCheck />
                            </button>
                            <button
                              className="btn-action btn-rechazar"
                              onClick={() => handleRechazarSolicitud(solicitud.id)}
                              title="Rechazar solicitud"
                            >
                              <FiX />
                            </button>
                          </>
                        )}
                        <button
                          className="btn-action btn-ver"
                          onClick={() => setExpandedSolicitud(expandedSolicitud === solicitud.id ? null : solicitud.id)}
                          title="Ver detalles"
                        >
                          <FiEye />
                        </button>
                      </div>
                    </td>
                  </tr>
                  {expandedSolicitud === solicitud.id && (
                    <tr className="expanded-row">
                      <td colSpan="9">
                        <div className="expanded-content">
                          <div className="details-grid">
                            <div className="detail-section">
                              <h4>Información del Recurso</h4>
                              <div className="detail-item">
                                <label>Código:</label>
                                <span>{solicitud.recurso_data?.codigo || '-'}</span>
                              </div>
                              <div className="detail-item">
                                <label>Nombre:</label>
                                <span>{solicitud.recurso_data?.nombre || '-'}</span>
                              </div>
                              <div className="detail-item">
                                <label>Tipo:</label>
                                <span>{solicitud.recurso_data?.tipo_recurso_data?.nombre || '-'}</span>
                              </div>
                              <div className="detail-item">
                                <label>Unidad de Medida:</label>
                                <span>{solicitud.recurso_data?.unidad_medida || '-'}</span>
                              </div>
                            </div>
                            <div className="detail-section">
                              <h4>Información de la Solicitud</h4>
                              <div className="detail-item">
                                <label>Cantidad Solicitada:</label>
                                <span>{solicitud.cantidad_solicitada} {solicitud.recurso_data?.unidad_medida || ''}</span>
                              </div>
                              <div className="detail-item">
                                <label>Fecha de Creación:</label>
                                <span>{formatFecha(solicitud.created_at)}</span>
                              </div>
                              <div className="detail-item">
                                <label>Estado:</label>
                                <span className={`estado-badge ${getEstadoBadgeClass(solicitud.estado)}`}>
                                  {solicitud.estado}
                                </span>
                              </div>
                              {solicitud.motivo_rechazo && (
                                <div className="detail-item">
                                  <label>Motivo de Rechazo:</label>
                                  <span className="text-danger">{solicitud.motivo_rechazo}</span>
                                </div>
                              )}
                            </div>
                            <div className="detail-section">
                              <h4>Contexto del Proyecto</h4>
                              <div className="detail-item">
                                <label>Proyecto:</label>
                                <span>{solicitud.proyecto_data?.nombre || '-'}</span>
                              </div>
                              <div className="detail-item">
                                <label>Cliente:</label>
                                <span>{solicitud.proyecto_data?.cliente_data?.nombre || '-'}</span>
                              </div>
                              <div className="detail-item">
                                <label>Evento:</label>
                                <span>{solicitud.evento_data?.nombre || '-'}</span>
                              </div>
                              <div className="detail-item">
                                <label>Tarea:</label>
                                <span>{solicitud.tarea_data?.nombre || '-'}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </div>
    );
  };

  const renderOrdenesCompra = () => {
    const stats = calcularEstadisticasOrdenes();
    return (
      <div className="ordenes-compra-page">
        {Object.keys(stats).length > 0 && renderCompactStats(stats, true)}
        {ordenesCompra.length === 0 ? (
          <div className="empty-state">
            <FiShoppingCart size={64} />
            <h3>No hay órdenes de compra</h3>
            <p>No se encontraron órdenes de compra registradas</p>
          </div>
        ) : (
          <div className="ordenes-table-container">
          <table className="ordenes-table">
            <thead>
              <tr>
                <th>N° OC</th>
                <th>Proyecto</th>
                <th>Proveedor</th>
                <th>Estado</th>
                <th>Tipo Doc.</th>
                <th>Fecha Emisión</th>
                <th>Total</th>
                <th>Items</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {ordenesCompra.map((orden) => (
                <React.Fragment key={orden.id}>
                  <tr className="orden-row">
                    <td className="numero-oc">
                      <strong>{orden.numero_oc}</strong>
                    </td>
                    <td>{orden.proyecto_nombre}</td>
                    <td>{orden.proveedor_nombre || '-'}</td>
                    <td>
                      <span className={`badge-estado ${getEstadoBadgeClass(orden.estado)}`}>
                        {orden.estado}
                      </span>
                    </td>
                    <td>
                      <span className="tipo-documento">
                        {orden.tipo_documento || '-'}
                      </span>
                    </td>
                    <td>{formatFecha(orden.fecha_emision)}</td>
                    <td className="total-oc">
                      <strong>{formatCurrency(orden.total_oc || 0)}</strong>
                    </td>
                    <td>
                      <span className="items-count">{orden.numero_items || 0}</span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <button
                          className="btn-icon-action"
                          onClick={() => handleEditarOrdenCompra(orden)}
                          title="Editar Orden"
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#2196F3',
                            padding: '4px'
                          }}
                        >
                          <FiEdit size={18} />
                        </button>
                        <button
                          className="btn-icon-action"
                          onClick={() => handleRecepcionarCompra(orden)}
                          title={orden.estado === 'recibida' ? 'Orden ya recibida completamente' : 'Recepcionar Compra'}
                          disabled={orden.estado === 'recibida'}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: orden.estado === 'recibida' ? 'not-allowed' : 'pointer',
                            color: orden.estado === 'recibida' ? '#ccc' : '#69B32D',
                            padding: '4px',
                            opacity: orden.estado === 'recibida' ? 0.5 : 1
                          }}
                        >
                          <FiPackage size={18} />
                        </button>
                        <button
                          className="btn-icon-action danger"
                          onClick={() => handleEliminarOrdenCompra(orden)}
                          title="Eliminar Orden"
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#f44336',
                            padding: '4px'
                          }}
                        >
                          <FiTrash2 size={18} />
                        </button>
                        <button
                          className="btn-expand"
                          onClick={() => setExpandedOrden(expandedOrden === orden.id ? null : orden.id)}
                          title={expandedOrden === orden.id ? "Ocultar detalles" : "Ver detalles"}
                        >
                          {expandedOrden === orden.id ? '▼' : '▶'}
                        </button>
                      </div>
                    </td>
                  </tr>
                  {expandedOrden === orden.id && (
                    <tr className="detalles-row">
                      <td colSpan="9">
                        <div className="detalles-container">
                          <div className="detalles-header">
                            <h4>Detalles de la Orden</h4>
                            {orden.descripcion && (
                              <p className="orden-descripcion">
                                <strong>Descripción:</strong> {orden.descripcion}
                              </p>
                            )}
                          </div>
                          {orden.detalles && orden.detalles.length > 0 ? (
                            <table className="detalles-table">
                              <thead>
                                <tr>
                                  <th>Recurso</th>
                                  <th>Descripción</th>
                                  <th>Cantidad</th>
                                  <th>Unidad</th>
                                  <th>Precio Unit.</th>
                                  <th>Subtotal</th>
                                  <th>Bodega</th>
                                </tr>
                              </thead>
                              <tbody>
                                {orden.detalles.map((detalle, idx) => (
                                  <tr key={detalle.id || idx}>
                                    <td>
                                      <div style={{ fontWeight: 600 }}>
                                        {detalle.recurso_data?.nombre || '-'}
                                      </div>
                                    </td>
                                    <td>{detalle.descripcion}</td>
                                    <td style={{ textAlign: 'center' }}>
                                      {parseFloat(detalle.cantidad).toFixed(2)}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>{detalle.unidad}</td>
                                    <td style={{ textAlign: 'right' }}>
                                      {formatCurrency(detalle.precio_unitario)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontWeight: 700 }}>
                                      {formatCurrency(detalle.subtotal)}
                                    </td>
                                    <td>{detalle.bodega_nombre || '-'}</td>
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colSpan="5" style={{ textAlign: 'right', fontWeight: 700 }}>
                                    TOTAL OC:
                                  </td>
                                  <td style={{ textAlign: 'right', fontWeight: 700 }}>
                                    {formatCurrency(orden.total_oc || 0)}
                                  </td>
                                  <td></td>
                                </tr>
                              </tfoot>
                            </table>
                          ) : (
                            <p className="no-detalles">Esta orden no tiene detalles registrados</p>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </div>
    );
  };

  const renderGuiasDespacho = () => {
    const stats = calcularEstadisticasGuias();
    return (
      <div>
        {Object.keys(stats).length > 0 && renderCompactStats(stats, true)}
        {guiasDespacho.length === 0 ? (
          <div className="empty-state">
            <FiPackage size={64} />
            <h3>No hay guías de despacho</h3>
            <p>No se encontraron guías de despacho registradas</p>
          </div>
        ) : (
          <table className="ordenes-table">
          <thead>
            <tr>
              <th>N° Guía</th>
              <th>OC</th>
              <th>Proveedor</th>
              <th>Proyecto</th>
              <th>Bodega</th>
              <th>Fecha Emisión</th>
              <th>Fecha Recepción</th>
              <th>Estado</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {guiasDespacho.map((guia) => (
              <tr key={guia.id}>
                <td><strong>{guia.numero_guia}</strong></td>
                <td>{guia.orden_compra_numero || '-'}</td>
                <td>{guia.proveedor_nombre || '-'}</td>
                <td>{guia.proyecto_nombre || '-'}</td>
                <td>{guia.bodega_nombre || '-'}</td>
                <td>{formatFecha(guia.fecha_emision)}</td>
                <td>{formatFecha(guia.fecha_recepcion)}</td>
                <td>
                  <span className={`badge-estado ${getEstadoBadgeClass(guia.estado)}`}>
                    {guia.estado_display || guia.estado}
                  </span>
                </td>
                <td><strong>{formatCurrency(guia.total_guia || 0)}</strong></td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
      </div>
    );
  };

  const renderDocumentosLegales = () => {
    const stats = calcularEstadisticasDocumentos();
    return (
      <div className="documentos-legales-page">
        <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            {Object.keys(stats).length > 0 && renderCompactStats(stats, true)}
          </div>
        </div>
        <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn-primary" onClick={handleCrearDocumento}>
            <FiPlus /> Nuevo Documento
          </button>
        </div>
        {documentosLegales.length === 0 ? (
          <div className="empty-state">
            <FiFileText size={64} />
            <h3>No hay documentos legales</h3>
            <p>No se encontraron documentos legales registrados</p>
          </div>
        ) : (
          <div className="documentos-table-container">
          <table className="documentos-table">
            <thead>
              <tr>
                <th>Número</th>
                <th>Tipo</th>
                <th>Fecha Emisión</th>
                <th>Proveedor/Cliente</th>
                <th>Proyecto</th>
                <th>Monto Total</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {documentosLegales.map(doc => (
                <React.Fragment key={doc.id}>
                  <tr
                    className={expandedDocumento === doc.id ? 'expanded' : ''}
                    onClick={() => setExpandedDocumento(expandedDocumento === doc.id ? null : doc.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="numero-documento">
                      {doc.numero_documento}
                    </td>
                    <td>
                      <span className={`badge ${getTipoBadgeClass(doc.tipo_documento)}`}>
                        {doc.tipo_documento_display}
                      </span>
                    </td>
                    <td>{formatFecha(doc.fecha_emision)}</td>
                    <td>
                      {doc.proveedor_nombre || doc.cliente_nombre || '-'}
                    </td>
                    <td>{doc.proyecto_nombre || '-'}</td>
                    <td className="monto-total">
                      {formatCurrency(doc.monto_total)}
                    </td>
                    <td>
                      <span className={`badge ${getEstadoBadgeClass(doc.estado)}`}>
                        {doc.estado_display}
                      </span>
                    </td>
                    <td className="acciones-cell" onClick={(e) => e.stopPropagation()}>
                      <button
                        className="btn-icon"
                        onClick={() => setExpandedDocumento(expandedDocumento === doc.id ? null : doc.id)}
                        title="Ver detalles"
                      >
                        <FiEye />
                      </button>
                      <button
                        className="btn-icon"
                        onClick={() => handleEditarDocumento(doc)}
                        title="Editar"
                      >
                        <FiEdit />
                      </button>
                      <button
                        className="btn-icon btn-danger"
                        onClick={() => handleEliminarDocumento(doc.id)}
                        title="Eliminar"
                      >
                        <FiTrash2 />
                      </button>
                    </td>
                  </tr>
                  {expandedDocumento === doc.id && doc.detalles && doc.detalles.length > 0 && (
                    <tr className="detalles-row">
                      <td colSpan="8">
                        <div className="detalles-container">
                          <h4>Detalles del Documento</h4>
                          <table className="detalles-table">
                            <thead>
                              <tr>
                                <th>Descripción</th>
                                <th>Cantidad</th>
                                <th>Unidad</th>
                                <th>Precio Unitario</th>
                                <th>Subtotal</th>
                              </tr>
                            </thead>
                            <tbody>
                              {doc.detalles.map((detalle, index) => (
                                <tr key={index}>
                                  <td>{detalle.descripcion}</td>
                                  <td>{detalle.cantidad}</td>
                                  <td>{detalle.unidad}</td>
                                  <td>{formatCurrency(detalle.precio_unitario)}</td>
                                  <td>{formatCurrency(detalle.subtotal)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="totales-documento">
                            <div className="total-row">
                              <span>Monto Neto:</span>
                              <span>{formatCurrency(doc.monto_neto)}</span>
                            </div>
                            <div className="total-row">
                              <span>IVA:</span>
                              <span>{formatCurrency(doc.monto_iva)}</span>
                            </div>
                            <div className="total-row total-final">
                              <span>Total:</span>
                              <span>{formatCurrency(doc.monto_total)}</span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </div>
    );
  };

  const renderMovimientos = () => {
    const stats = calcularEstadisticasMovimientos();
    return (
      <div>
        {Object.keys(stats).length > 0 && renderCompactStats(stats)}
        {movimientos.length === 0 ? (
          <div className="empty-state">
            <FiTrendingUp size={64} />
            <h3>No hay movimientos de inventario</h3>
            <p>No se encontraron movimientos registrados</p>
          </div>
        ) : (
          <table className="ordenes-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Tipo</th>
              <th>Bodega</th>
              <th>Recurso</th>
              <th>Cantidad</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th>Documento</th>
            </tr>
          </thead>
          <tbody>
            {movimientos.map(mov => (
              <tr key={mov.id}>
                <td><strong>#{mov.id}</strong></td>
                <td>
                  <span className={`badge ${
                    mov.tipo_movimiento === 'entrada' ? 'badge-success' :
                    mov.tipo_movimiento === 'salida' ? 'badge-danger' : 'badge-info'
                  }`}>
                    {mov.tipo_movimiento_display || mov.tipo_movimiento}
                  </span>
                </td>
                <td>{mov.bodega_nombre || '-'}</td>
                <td>{mov.recurso_nombre || '-'}</td>
                <td>{mov.cantidad || 0}</td>
                <td>{formatFecha(mov.fecha_movimiento)}</td>
                <td>
                  <span className={`badge ${getEstadoBadgeClass(mov.estado)}`}>
                    {mov.estado_display || mov.estado}
                  </span>
                </td>
                <td>{mov.numero_documento || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return <Loading />;
    }

    switch (activeTab) {
      case 'tareas':
        return renderTareas();
      case 'solicitudes':
        return renderSolicitudes();
      case 'ordenes':
        return renderOrdenesCompra();
      case 'guias':
        return renderGuiasDespacho();
      case 'documentos':
        return renderDocumentosLegales();
      case 'movimientos':
        return renderMovimientos();
      default:
        return null;
    }
  };

  const tabs = [
    { id: 'tareas', label: 'Tareas', icon: FiCalendar, count: tareas.length },
    { id: 'solicitudes', label: 'Solicitudes', icon: FiFileText, count: solicitudes.length },
    { id: 'ordenes', label: 'Órdenes de Compra', icon: FiShoppingCart, count: ordenesCompra.length },
    { id: 'guias', label: 'Guías Despacho', icon: FiPackage, count: guiasDespacho.length },
    { id: 'documentos', label: 'Documentos Legales', icon: FiFileText, count: documentosLegales.length },
    { id: 'movimientos', label: 'Movimientos', icon: FiTrendingUp, count: movimientos.length }
  ];

  return (
    <div className="page-container">
      {/* Header */}
      <div className="page-header">
        <div className="header-left">
          <FiTrendingUp size={32} className="page-icon" />
          <div>
            <h1>Workflow</h1>
            <p className="page-subtitle">Centro de control de documentos y procesos</p>
          </div>
        </div>
        <div className="header-actions">
          <button
            className="btn-primary"
            onClick={cargarDatos}
          >
            <FiRefreshCw size={18} />
            Actualizar
          </button>
        </div>
      </div>

      {/* Tabs Navigation */}
      <div style={{
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        marginBottom: '1.5rem',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          display: 'flex',
          gap: '0',
          overflowX: 'auto',
          padding: '0 1rem'
        }}>
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '1rem 1.5rem',
                  border: 'none',
                  background: activeTab === tab.id ? 'white' : 'transparent',
                  borderBottom: activeTab === tab.id ? '3px solid #102826' : '3px solid transparent',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontWeight: activeTab === tab.id ? '600' : '400',
                  color: activeTab === tab.id ? '#102826' : '#6b7280',
                  transition: 'all 0.2s',
                  whiteSpace: 'nowrap'
                }}
              >
                <Icon size={18} />
                {tab.label}
                {tab.count > 0 && (
                  <span style={{
                    background: '#102826',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '0.125rem 0.5rem',
                    fontSize: '0.75rem',
                    fontWeight: '600'
                  }}>
                    {tab.count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div style={{ minHeight: '400px' }}>
        {renderContent()}
      </div>

      {/* Modales para Solicitudes */}
      {showCrearOCModal && presupuestoData && itemsSeleccionados.length > 0 && (
        <CrearOrdenCompraOneBaseModal
          presupuesto={presupuestoData}
          itemsSeleccionados={itemsSeleccionados}
          onClose={() => {
            setShowCrearOCModal(false);
            setSolicitudParaAprobar(null);
            setPresupuestoData(null);
            setItemsSeleccionados([]);
          }}
          onCreated={handleOCCreada}
        />
      )}

      {/* Modales para Órdenes de Compra */}
      {showVerEditarOC && ordenCompraParaVer && (
        <VerEditarOrdenCompraModal
          ordenCompra={ordenCompraParaVer}
          onClose={() => {
            setShowVerEditarOC(false);
            setOrdenCompraParaVer(null);
          }}
          onUpdated={() => {
            cargarOrdenesCompra();
          }}
          readOnly={false}
        />
      )}

      {showRecepcionModal && ordenCompraParaRecepcionar && (
        <RecepcionarCompraModal
          show={showRecepcionModal}
          ordenCompra={ordenCompraParaRecepcionar}
          onClose={() => {
            setShowRecepcionModal(false);
            setOrdenCompraParaRecepcionar(null);
          }}
          onSuccess={() => {
            cargarOrdenesCompra();
            cargarGuiasDespacho();
            cargarMovimientos();
          }}
        />
      )}

      {/* Modal para Documentos Legales */}
      {showDocumentoModal && (
        <CrearEditarDocumentoLegalModal
          onClose={() => {
            setShowDocumentoModal(false);
            setDocumentoEdit(null);
          }}
          onCreate={cargarDocumentosLegales}
          documentoEdit={documentoEdit}
        />
      )}
    </div>
  );
};

export default FlujoProcesosPage;
